import React, { FC, useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import TableTab from "../components/tabs/table-tab";
import { MESSAGES } from "../constants/menu-types";
import { useLocale } from "../contexts/localeContext";
import { TableContextProvider } from "../contexts/table/TableContextProvider";
import { TranslationKeys } from "../contexts/TranslationKeys";
import { Category } from "../models/Category";
import columns from '../models/ColumnDefinitions/MessageColumns';
import { Lookup } from "../models/Lookup";
import LookupTypes from "../models/LookupTypes";
import searchColumns from '../models/search/MessageSearch';
import SiteSearch from "../models/search/SiteSearch";
import { DeleteEntityResult } from "../models/services/DeleteEntityResult";
import { deleteMessage, getMessages } from "../services/messageService";
import { getSiteNamesWithPagination } from "../services/siteService";
import { Filter } from "../models/Filter";
import TableContextStateMonitor from "../contexts/table/TableContextStateMonitor";
interface Props {
    setBusy: (isBusy: boolean) => void,
    categories: Category[],
    setCategories: (category: Category[]) => void,
    onFilterChange: (filters: Filter[]) => void

}

const MessagesTab: FC<Props> = ({ setBusy, categories, setCategories, onFilterChange }) => {
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.messages);
    const [lookup, setLookup] = useState<Lookup[]>([]);
    const itemPath = '/access-control/configuration/message/';

    useEffect(() => {
        (async () => {
            setLookup([{
                name: LookupTypes.site,
                values: [],
                dataMethod: getSiteNamesWithPagination,
                searchAccessor: SiteSearch.find(item => item.accessor === "name")?.searchOnName
            }]);
        })();
    }, [])

    const onDelete = (id: string): Promise<DeleteEntityResult> => {
        setBusy(true);
        return new Promise((resolve, reject) => {
            deleteMessage(id)
                .then(
                    deleteResult => {
                        resolve(deleteResult);
                        setCategories([{ ...categories[0], count: (categories[0]?.count ?? 1) - 1 }]);
                        setBusy(false);
                    },
                    deleteResult => {
                        reject(deleteResult);
                        setBusy(false);
                    })
        });
    }

    // user preference items
    const userLoginId = useSelector((state: any) => (state.userInfo.id))
    const initialiseUserPreferences = (setDetails: (userLoginId, MESSAGES) => void) => {
        setDetails(userLoginId, MESSAGES);
    }
    // <-- end context

    return <TableContextProvider
        initialiser={(setDetails) => initialiseUserPreferences(setDetails)}
        dataMethod={getMessages}
        tableDescriptor={columns}
        searchDescriptor={searchColumns}
        useTable
        usePagination
        useSearch
        useSort
        useFilter
        deleteMethod={onDelete}
        lookup={lookup}
        customDelete={{ fieldName: "isDefault", comparisonValue: false }}>
        <TableContextStateMonitor onFilterChange={onFilterChange} />
        <TableTab
            title={title}
            rowPath={itemPath}
            selectRows={false} 
            cyName="messages"/>
    </TableContextProvider>
};

export default MessagesTab;
